<template>
  <div class="join-wrap w1200">
    <el-breadcrumb separator="-" class="hidden-sm-and-down">
      <div class="icon">
        <img src="../../assets/images/loca-icon.png" alt="" class="img">
      </div>
      <el-breadcrumb-item :to="{ path: '/join' }">加盟咨询</el-breadcrumb-item>
      <el-breadcrumb-item>加盟申请</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="content-wrap">
      <div class="tit">加盟申请</div>
      <div class="desc">{{info.title}}</div>
      <div class="code">

        <div class="img">
          <el-image
            style="width: 100%; height: 100%"
            :src="info.image"
            fit="cover"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>

        <div class="img">
          <el-image
                  style="width: 100%; height: 100%"
                  :src="info.images"
                  fit="cover"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "appleyforJoin",

    data() {
      return {
        info: {}
      }
    },

    created() {
      this.getInfo()
    },

    methods: {
      getInfo() {
        this.$http.post('/api/login/leagues', {page: this.currentPage}).then(res => {
          if (res.code === 0) {
            this.info = res.data
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .el-breadcrumb {
    border-bottom: 1px solid #ccc;
    padding-bottom: 15px;
    position: relative;
    padding-left: 20px;
    .icon {
      position: absolute;
      top: 0;
      left: 0;
      width: 12px;
      height: 12px;
    }
  }
  .join-wrap {
    padding: 60px 0;
  }
  .content-wrap {
    width:860px;
    height:580px;
    margin: 60px auto 0;
    background:rgba(255,255,255,1);
    box-shadow:0px 1px 8px 1px rgba(35,24,21,0.15);
    border-radius:20px;
    .tit {
      font-size:24px;
      font-weight:bold;
      color:rgba(38,38,38,1);
      padding-top: 49px;
    }
    .desc {
      width: 412px;
      margin: 47px auto 42px;
    }
    .code {
      width: 520px;
      height:250px;
      margin: 0 auto;
      overflow: hidden;
      .img {
        width: 250px;
        height:  250px;
        overflow: hidden;
        border-radius:20px;
        background:rgba(229,229,229,1);
        float: left;
        &:first-child {
          margin-right: 20px;
        }
      }
    }
  }
  @media only screen and (max-width: 991px) {
    .join-wrap {
      padding: 16vw  /* 120/7.5 */ 0 0 0;
      width: 100vw  /* 750/7.5 */;
    }
    .content-wrap {
      width: 93.33vw  /* 700/7.5 */;
      height: 80vw  /* 600/7.5 */;
      margin: 0 auto 2.67vw  /* 20/7.5 */;
      padding: 3.33vw  /* 25/7.5 */;
      box-sizing: border-box;
      .tit {
        margin: 0;
        font-size: 4.8vw  /* 36/7.5 */;
        padding-top: 2.67vw  /* 20/7.5 */;
      }
      .desc {
        width: 93.33vw  /* 700/7.5 */;
        margin: 6.4vw  /* 48/7.5 */ 0 5.33vw  /* 40/7.5 */;
      }
      .code {
        width: 69.33vw  /* 520/7.5 */;
        height:33.33vw  /* 250/7.5 */;
        margin: 0 auto;
        .img {
          width: 33.33vw  /* 250/7.5 */;
          height:  33.33vw  /* 250/7.5 */;
          overflow: hidden;
          border-radius:2.67vw  /* 20/7.5 */;
          background:rgba(229,229,229,1);
          float: left;
          &:first-child {
            margin-right: 2.67vw  /* 20/7.5 */;
          }
        }
      }
    }
  }
</style>